import React from "react"

const Footer = () => {

    return (
     <footer>
        <p> <a href="https://bitbucket.org/mwebster_/index/src">BitBucket</a> | <a href="https://twitter.com/motiondesign_01">Twitter</a> | <a href="mailto:mark.webster@wanadoo.fr">Email</a></p>
    </footer>
    )
}

export default Footer

